module.exports = __webpack_public_path__ + "static_portal/media/bg2-video.0faccda9.mp4";